import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductVariantService {

  constructor(private httpClientService: HttpClientService) { }

  async updateProductVariant(productVariantDefinition) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.ProductVariant,
    }, productVariantDefinition);
    return await firstValueFrom(observable);
  }
  
  async getByIdProductVariants(id){
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.ProductVariant,
    },id);
    return await firstValueFrom(observable);
  }

  async getProductVaryantValues(id){
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.ProductVariant,
      action: "GetProductVaryantValues"
    }, id);
    return await firstValueFrom(observable);
  }
}
